import React, { useState, useEffect } from "react";
import ProductAutocomplete from "../common/ProductAutocomplete";
import "../../components/common/Modal.css";
import "../../assets/styles/common.css";
import "./Inventory.css";

const BulkStockFormModal = ({ isOpen, onClose, onSubmit, products }) => {
  const [stockItems, setStockItems] = useState([
    {
      productId: "",
      productName: "", // NEW: Store product name for display
      batchNumber: "",
      stockNumber: "",
      manufacturingDate: "",
      expirationDate: "",
      cost: "",
      notes: "",
      errors: {},
    },
  ]);

  useEffect(() => {
    if (isOpen) {
      setStockItems([
        {
          productId: "",
          productName: "",
          batchNumber: "",
          stockNumber: "",
          manufacturingDate: "",
          expirationDate: "",
          cost: "",
          notes: "",
          errors: {},
        },
      ]);
    }
  }, [isOpen]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...stockItems];
    list[index][name] = value;
    if (list[index].errors[name]) {
      list[index].errors[name] = "";
    }
    setStockItems(list);
  };

  const handleProductSelect = (index, product) => {
    const list = [...stockItems];
    list[index].productId = product.id;
    list[index].productName = `${product.brandName} (${product.genericName})`;
    if (list[index].errors.productId) {
      list[index].errors.productId = "";
    }
    setStockItems(list);
  };

  const handleRemoveProduct = (index) => {
    const list = [...stockItems];
    list[index] = {
      productId: "",
      productName: "",
      batchNumber: "",
      stockNumber: "",
      manufacturingDate: "",
      expirationDate: "",
      cost: "",
      notes: "",
      errors: {},
    };
    setStockItems(list);
  };

  const handleAddRow = () => {
    setStockItems([
      ...stockItems,
      {
        productId: "",
        productName: "",
        batchNumber: "",
        stockNumber: "",
        manufacturingDate: "",
        expirationDate: "",
        cost: "",
        notes: "",
        errors: {},
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const list = [...stockItems];
    list.splice(index, 1);
    setStockItems(list);
  };

  const validateForm = () => {
    let formIsValid = true;
    const updatedItems = stockItems.map((item) => {
      const newErrors = {};
      if (!item.productId) newErrors.productId = "Product is required.";
      if (!item.stockNumber)
        newErrors.stockNumber = "Stock Number is required.";
      if (isNaN(item.stockNumber) || parseInt(item.stockNumber) <= 0)
        newErrors.stockNumber = "Stock must be a positive number.";
      if (!item.manufacturingDate)
        newErrors.manufacturingDate = "Manufacturing Date is required.";
      if (!item.expirationDate)
        newErrors.expirationDate = "Expiration Date is required.";
      if (item.cost === "" || isNaN(item.cost) || parseFloat(item.cost) <= 0)
        newErrors.cost = "Valid cost is required.";

      if (Object.keys(newErrors).length > 0) {
        formIsValid = false;
      }
      return { ...item, errors: newErrors };
    });
    setStockItems(updatedItems);
    return formIsValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formattedItems = stockItems.map((item) => ({
        productId: item.productId,
        batchNumber: item.batchNumber,
        stockNumber: parseInt(item.stockNumber),
        manufacturingDate: item.manufacturingDate,
        expirationDate: item.expirationDate,
        cost: parseFloat(item.cost),
        notes: item.notes,
      }));
      onSubmit(formattedItems);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content bulk-stock-modal-content">
        {/* <div className="modal-header">
          <h2>Add Multiple Stocks</h2>
          <button className="modal-close-button" onClick={onClose}>
            &times;
          </button>
        </div> */}
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="bulk-stock-items-container">
            {stockItems.map((item, index) => (
              <div key={index} className="bulk-stock-item-row">
                <div className="form-group product-autocomplete-group">
                  <label>Product:</label>
                  {item.productId ? (
                    <div className="selected-product-tag">
                      {item.productName}
                      <button
                        type="button"
                        onClick={() => handleRemoveProduct(index)}
                        className="button button-icon-only"
                      >
                        &times;
                      </button>
                    </div>
                  ) : (
                    <ProductAutocomplete
                      products={products}
                      onSelect={(product) =>
                        handleProductSelect(index, product)
                      }
                      selectedIds={stockItems
                        .map((si) => si.productId)
                        .filter((id) => id)}
                      placeholder="Search and select product..."
                    />
                  )}
                  {item.errors.productId && (
                    <span className="error-message">
                      {item.errors.productId}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>Stock No:</label>
                  <input
                    type="number"
                    name="stockNumber"
                    value={item.stockNumber}
                    onChange={(e) => handleChange(index, e)}
                    className={`form-input ${
                      item.errors.stockNumber ? "input-error" : ""
                    }`}
                  />
                  {item.errors.stockNumber && (
                    <span className="error-message">
                      {item.errors.stockNumber}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>Cost:</label>
                  <input
                    type="number"
                    name="cost"
                    value={item.cost}
                    onChange={(e) => handleChange(index, e)}
                    step="0.01"
                    className={`form-input ${
                      item.errors.cost ? "input-error" : ""
                    }`}
                  />
                  {item.errors.cost && (
                    <span className="error-message">{item.errors.cost}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Mfg. Date:</label>
                  <input
                    type="date"
                    name="manufacturingDate"
                    value={item.manufacturingDate}
                    onChange={(e) => handleChange(index, e)}
                    className={`form-input ${
                      item.errors.manufacturingDate ? "input-error" : ""
                    }`}
                  />
                  {item.errors.manufacturingDate && (
                    <span className="error-message">
                      {item.errors.manufacturingDate}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>Exp. Date:</label>
                  <input
                    type="date"
                    name="expirationDate"
                    value={item.expirationDate}
                    onChange={(e) => handleChange(index, e)}
                    className={`form-input ${
                      item.errors.expirationDate ? "input-error" : ""
                    }`}
                  />
                  {item.errors.expirationDate && (
                    <span className="error-message">
                      {item.errors.expirationDate}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label>Notes:</label>
                  <input
                    type="text"
                    name="notes"
                    value={item.notes}
                    onChange={(e) => handleChange(index, e)}
                    className="form-input"
                  />
                </div>
                {stockItems.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveRow(index)}
                    className="button button-icon-only remove-row-button"
                  >
                    &times;
                  </button>
                )}
              </div>
            ))}
          </div>
          <button
            type="button"
            onClick={handleAddRow}
            className="button button-secondary add-row-button"
          >
            Add Another Row
          </button>
          <div className="modal-actions">
            <button type="submit" className="button button-primary">
              Save All Stocks
            </button>
            <button
              type="button"
              onClick={onClose}
              className="button button-secondary"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkStockFormModal;
